export default __webpack_public_path__ + "static/media/AZ-State-Museum-Logo_white copy.fd880d95.png";